export const CO_COLLECTION_ADD = "CO_COLLECTION_ADD"
export const CO_COLLECTION_SUCCESS = "CO_COLLECTION_SUCCESS"
export const CO_COLLECTION_FAIL = "CO_COLLECTION_FAIL"

export const CO_GET_COLLECTION_LISTING = "CO_GET_COLLECTION_LISTING"
export const CO_GET_COLLECTION_LISTING_SUCCESS =
  "CO_GET_COLLECTION_LISTING_SUCCESS"
export const CO_GET_COLLECTION_LISTING_FAILED =
  "CO_GET_COLLECTION_LISTING_FAILED"

export const CO_COLLECTION_EDIT = "CO_COLLECTION_EDIT"
export const CO_COLLECTION_EDIT_SUCCESS = "CO_COLLECTION_EDIT_SUCCESS"
export const CO_COLLECTION_EDIT_FAIL = "CO_COLLECTION_EDIT_FAIL"

export const CO_COLLECTION_UPDATE = "CO_COLLECTION_UPDATE"
export const CO_COLLECTION_UPDATE_SUCCESS = "CO_COLLECTION_UPDATE_SUCCESS"
export const CO_COLLECTION_UPDATE_FAIL = "CO_COLLECTION_UPDATE_FAIL"

export const CO_COLLECTION_DELETE = "CO_COLLECTION_DELETE"
export const CO_COLLECTION_DELETE_SUCCESS = "CO_COLLECTION_DELETE_SUCCESS"
export const CO_COLLECTION_DELETE_FAIL = "CO_COLLECTION_DELETE_FAIL"

export const CO_EXPORTCOLLECTIONCATALOG_DOWNLOAD =
  "CO_EXPORTCOLLECTIONCATALOG_DOWNLOAD"
export const CO_EXPORTCOLLECTIONCATALOG_DOWNLOAD_SUCCESS =
  "CO_EXPORTCOLLECTIONCATALOG_DOWNLOAD_SUCCESS"
export const CO_EXPORTCOLLECTIONCATALOG_DOWNLOAD_FAIL =
  "CO_EXPORTCOLLECTIONCATALOG_DOWNLOAD_FAIL"

export const CO_COLLECTION_COPY = "CO_COLLECTION_COPY"
export const CO_COLLECTION_COPY_SUCCESS = "CO_COLLECTION_COPY_SUCCESS"
export const CO_COLLECTION_COPY_FAIL = "CO_COLLECTION_COPY_FAIL"

export const CO_EXPORTDOWNLOAD_PROGRESS = "CO_EXPORTDOWNLOAD_PROGRESS"
export const CO_EXPORTDOWNLOAD_PROGRESS_SUCCESS =
  "CO_EXPORTDOWNLOAD_PROGRESS_SUCCESS"
export const CO_EXPORTDOWNLOAD_PROGRESS_FAIL = "CO_EXPORTDOWNLOAD_PROGRESS_FAIL"

export const CO_ADD_MORE_TO_COLLECTION = "CO_ADD_MORE_TO_COLLECTION"
export const CO_ADD_MORE_TO_COLLECTION_SUCCESS =
  "CO_ADD_MORE_TO_COLLECTION_SUCCESS"
export const CO_ADD_MORE_TO_COLLECTION_FAIL = "CO_ADD_MORE_TO_COLLECTION_FAIL"

export const CO_ADD_MORE_TO_COLLECTION_UPDATE =
  "CO_ADD_MORE_TO_COLLECTION_UPDATE"
export const CO_ADD_MORE_TO_COLLECTION_UPDATE_SUCCESS =
  "CO_ADD_MORE_TO_COLLECTION_UPDATE_SUCCESS"
export const CO_ADD_MORE_TO_COLLECTION_UPDATE_FAIL =
  "CO_ADD_MORE_TO_COLLECTION_UPDATE_FAIL"

export const CO_GET_PRODUCTS_FOR_ADD_COLLECTION =
  "CO_GET_PRODUCTS_FOR_ADD_COLLECTION"
export const CO_GET_PRODUCTS_FOR_ADD_COLLECTION_SUCCESS =
  "CO_GET_PRODUCTS_FOR_ADD_COLLECTION_SUCCESS"
export const CO_GET_PRODUCTS_FOR_ADD_COLLECTION_FAIL =
  "CO_GET_PRODUCTS_FOR_ADD_COLLECTION_FAIL"

export const CO_GET_PRODUCT_OFFER_FOR_ADD_COLLECTION =
  "CO_GET_PRODUCT_OFFER_FOR_ADD_COLLECTION"
export const CO_GET_PRODUCT_OFFER_FOR_ADD_COLLECTION_SUCCESS =
  "CO_GET_PRODUCT_OFFER_FOR_ADD_COLLECTION_SUCCESS"
export const CO_GET_PRODUCTS_OFFER_FOR_ADD_COLLECTION_FAIL =
  "CO_GET_PRODUCTS_OFFER_FOR_ADD_COLLECTION_FAIL"

export const CO_REFRESH_COLLECTION_COUNT = "CO_REFRESH_COLLECTION_COUNT"
export const CO_REFRESH_COLLECTION_COUNT_SUCCESS =
  "CO_REFRESH_COLLECTION_COUNT_SUCCESS"
export const CO_REFRESH_COLLECTION_COUNT_FAIL =
  "CO_REFRESH_COLLECTION_COUNT_FAIL"
